import { FuseNavigation } from "@fuse/types";

export const navigation: FuseNavigation[] = [
    {
        id: "dashboard",
        title: "Resumen",
        translate: "NAV.DASHBOARD.TITLE",
        type: "item",
        icon: "bar_chart",
        url: "/dashboard",
    },
    {
        id: "configuracion",
        title: "configuración",
        type: "collapsable",
        translate: "NAV.CONFIGURACION.TITLE",
        icon: "settings",
        children: [
            {
                id: "tiposDeEvaluacion",
                title: "Tipos de evaluación",
                translate: "NAV.TIPOEVALUACION.TITLE",
                type: "item",
                icon: "toc",
                url: "/tipos-evaluacion",
            },
            {
                id: "objetivos",
                title: "objetivos",
                translate: "NAV.OBJETIVOS.TITLE",
                type: "item",
                icon: "track_changes",
                url: "/objetivos",
            },
            {
                id: "dimensiones",
                title: "Dimensiones Riesgos",
                translate: "NAV.DIMENSIONES_RIESGOS.TITLE",
                type: "item",
                icon: "group_work",
                url: "/dimensiones-riesgos",
            },
            {
                id: "estructurasJerarquicas",
                title: "Estructuras Jerárquicas",
                translate: "NAV.ESTRUCTURAS_JERARQUICAS.TITLE",
                type: "item",
                icon: "domain",
                url: "/estructuras-jerarquicas",
            },
            {
                id: "factoresDePonderacion",
                title: "Factores de ponderación",
                translate: "NAV.FACTORES_DE_PONDERACION.TITLE",
                type: "item",
                icon: "group",
                url: "/factores-de-ponderacion",
            },
            {
                id: "reglasBase",
                title: "Reglas Base",
                translate: "NAV.REGLAS_BASE.TITLE",
                type: "item",
                icon: "tune",
                url: "/reglas-base",
            },
            {
                id: "marcoDeReferencia",
                title: "Marcos de Referencia",
                translate: "NAV.MARCOS_DE_REFERENCIA.TITLE",
                type: "item",
                icon: "library_books",
                url: "/marcos-de-referencia",
            },
            {
                id: "riesgos",
                title: "Riesgos",
                translate: "NAV.RIESGOS.TITLE",
                type: "item",
                icon: "warning_amber",
                url: "/riesgos",
            },
            {
                id: "controles",
                title: "Controles",
                translate: "NAV.CONTROLES.TITLE",
                type: "item",
                icon: "layers",
                url: "/controles",
            },
            {
                id: "escenario",
                title: "Escenario",
                translate: "NAV.ESCENARIO.TITLE",
                type: "item",
                icon: "running_with_errors",
                url: "/escenario",
            },
            {
                id: "tablaDeEvaluacion",
                title: "Tablas de evaluación",
                translate: "NAV.TABLADEEVALUACION.TITLE",
                type: "item",
                icon: "assignment_turned_in",
                url: "/tablas-de-evaluacion",
            },
        ],
    },
    {
        id: "usuarios",
        title: "Usuarios",
        translate: "NAV.USUARIOS.TITLE",
        type: "item",
        icon: "groups",
        url: "/usuarios",
    },
    {
        id: "evaluaciones",
        title: "Evaluaciones",
        type: "collapsable",
        translate: "NAV.EVALUACIONES.TITLE",
        icon: "fact_check",
        children: [
            {
                id: "preiniciarEvaluacion",
                title: "Preiniciar Evaluación",
                translate: "NAV.PREINICIAREVALUACION.TITLE",
                type: "item",
                icon: "post_add",
                url: "/preiniciar-evaluacion",
            },
            {
                id: "misEvaluaciones",
                title: "Mis Evaluaciones",
                translate: "NAV.MIS_EVALUACIONES.TITLE",
                type: "item",
                icon: "supervisor_account",
                url: "/mis-evaluaciones",
            },
            {
                id: "todasLasEvaluaciones",
                title: "Todas las Evaluaciones",
                translate: "NAV.TODAS_LAS_EVALUACIONES.TITLE",
                type: "item",
                icon: "list",
                url: "/todas-las-evaluaciones",
            },
            {
                id: "seguimientoKri",
                title: "Seguimiento de KRI",
                translate: "NAV.SEGUIMIENTO_DE_KRI.TITLE",
                type: "item",
                icon: "manage_search",
                url: "/seguimiento-de-kri",
            },
            {
                id: "seguimientoMisKri",
                title: "Mis KRI",
                translate: "NAV.MIS_KRI.TITLE",
                type: "item",
                icon: "playlist_add_check",
                url: "/mis-kri",
            },
        ],
    },
    {
        id: "consolidacion",
        title: "Consolidación",
        type: "collapsable",
        translate: "NAV.CONSOLIDACION.TITLE",
        icon: "compare_arrows",
        children: [
            {
                id: "consolidar",
                title: "Consolidar",
                translate: "NAV.CONSOLIDAR.TITLE",
                type: "item",
                icon: "compare_arrows",
                url: "/consolidar",
            },
            {
                id: "misEvaluacionesConsolidadas",
                title: "Mis Evaluaciones Consolidadas",
                translate: "NAV.MIS_EVALUACIONES_CONSOLIDADAS.TITLE",
                type: "item",
                icon: "supervisor_account",
                url: "/mis-evaluaciones-consolidadas",
            },
            {
                id: "todasLasEvaluacionesConsolidadas",
                title: "Todas las Evaluaciones Consolidadas",
                translate: "NAV.TODAS_LAS_EVALUACIONES_CONSOLIDADAS.TITLE",
                type: "item",
                icon: "list",
                url: "/todas-las-evaluaciones-consolidadas",
            },
        ],
    },
    {
        id: "analisisDeBrechas",
        title: "Análisis de Brechas",
        type: "collapsable",
        translate: "NAV.ANALISIS_DE_BRECHAS.TITLE",
        icon: "checklist_rtl",
        children: [
            {
                id: "iniciarAnalisisDeBrechas",
                title: "Iniciar Análisis de Brechas",
                translate: "NAV.INICIAR_ANALISIS_DE_BRECHAS.TITLE",
                type: "item",
                icon: "check_box",
                url: "/iniciar-analisis-de-brechas",
            },
            {
                id: "misAnalisisDeBrechas",
                title: "Mis Análisis de Brechas",
                translate: "NAV.MIS_ANALISIS_DE_BRECHAS.TITLE",
                type: "item",
                icon: "supervisor_account",
                url: "/mis-analisis-de-brechas",
            },
            {
                id: "todosLosAnalisisDeBrechas",
                title: "Todos los Análisis de brechas",
                translate: "NAV.TODOS_LOS_ANALISIS_DE_BRECHAS.TITLE",
                type: "item",
                icon: "list",
                url: "/todos-los-analisis-de-brechas",
            },
        ],
    },
    {
        id: "listados",
        title: "Listados",
        type: "collapsable",
        translate: "NAV.LISTADOS.TITLE",
        icon: "list",
        children: [
            {
                id: "listadoDetalladoDeLaEvaluacion",
                title: "Listado detallado de la evaluación",
                translate: "NAV.LISTADO_DETALLADO_DE_LA_EVALUACION.TITLE",
                type: "item",
                icon: "",
                url: "/listado-detallado-de-la-evaluacion",
            },
            /*{
      id       : 'listadoDetalladoDeUnaEvaluacionConsolidada',
      title    : 'Listado detallado de una evaluación consolidada',
      translate: 'NAV.LISTADO_DETALLADO_DE_LA_EVALUACION_CONSOLIDADA.TITLE',
      type     : 'item',
      icon     : 'group_add',
      url      : '/listado-detallado-de-la-evaluacion-consolidada',
    },*/
            {
                id: "listadoDeControlesSugeridos",
                title: "Listado de controles sugeridos",
                translate: "NAV.LISTADO_DE_CONTROLES_SUGERIDOS.TITLE",
                type: "item",
                icon: "",
                url: "/listado-de-controles-sugeridos",
            },
            {
                id: "listadoDeMedidasDeContingencia",
                title: "Listado de medidas de contingencia",
                translate: "NAV.LISTADO_DE_MEDIDAS_DE_CONTINGENCIA.TITLE",
                type: "item",
                icon: "",
                url: "/listado-de-medidas-de-contingencia",
            },
            {
                id: "listadoDeKri",
                title: "Listado de KRI",
                translate: "NAV.LISTADO_DE_KRI.TITLE",
                type: "item",
                icon: "",
                url: "/listado-de-kri",
            },
            /*{
      id       : 'listadoDeEvolucionDeKri',
      title    : 'Listado de Evolución de KRI',
      translate: 'NAV.LISTADO_DE_EVOLUCION_DE_KRI.TITLE',
      type     : 'item',
      icon     : 'group_add',
      url      : '/listado-de-evolucion-de-kri'
    }
    ,*/
            {
                id: "listadoDeControlesCriticos",
                title: "Listado de controles críticos",
                translate: "NAV.LISTADO_DE_CONTROLES_CRITICOS.TITLE",
                type: "item",
                icon: "",
                url: "/listado-controles-criticos",
            },
            {
                id: "listadoDeCumplimiento",
                title: "Listado de cumplimiento",
                translate: "NAV.LISTADO_DE_CUMPLIMIENTO.TITLE",
                type: "item",
                icon: "",
                url: "/listado-de-cumplimiento",
            },
            {
                id: "verPistasDeAuditoria",
                title: "Ver pistas de auditoría",
                translate: "NAV.VER_PISTAS_DE_AUDITORIA.TITLE",
                type: "item",
                icon: "",
                url: "/ver-pistas-de-auditoria",
            },
        ],
    },

    {
        id: "debidaDiligencia",
        title: "Debida diligancia",
        type: "collapsable",
        translate: "NAV.DEBIDA_DILIGENCIA.TITLE",
        icon: "checklist_rtl",
        children: [
            {
                id: "configuracionDiligencia",
                title: "Configuración",
                type: "collapsable",
                translate: "NAV.TABLAS.TITLE",
                icon: "settings",
                children: [
                    {
                        id: "sectorActividadSujetoObligadoDiligencia",
                        title: "Sector / Actividad",
                        translate: "NAV.SECTOR_ACTIVIDAD_SUJETO_OBLIGADO.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/sector-actividad-sujeto-obligado-debida-diligencia",
                    },
                    {
                        id: "monedaoDiligencia",
                        title: "Moneda",
                        translate: "NAV.MONEDA.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/moneda-debida-diligencia",
                    },
                    {
                        id: "paisDiligencia",
                        title: "País",
                        translate: "NAV.RIESGO_PAIS.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/pais-debida-diligencia",
                    },
                    {
                        id: "origenDeFondosDiligencia",
                        title: "Origen de fondos",
                        translate: "NAV.ORIGEN_DE_FONDOS.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/origen-de-fondos-debida-diligencia",
                    },
                    {
                        id: "profesionSujetoObligadoDiligencia",
                        title: "Tipo de sujeto obligado",
                        translate: "NAV.PROFESION_SUJETO_OBLIGADO.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/profesion-sujeto-obligado-debida-diligencia",
                    },
                    {
                        id: "ponderacionDeRiesgosDiligencia",
                        title: "Ponderación de riesgos",
                        translate: "NAV.PONDERACION_DE_RIESGOS.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/ponderacion-de-riesgos-debida-diligencia",
                    },
                    {
                        id: "tipoDocumentoSujetoObligadoDiligencia",
                        title: "Tipo de documento",
                        translate:
                            "NAV.TIPO_DOCUMENTO_ACTIVIDAD_SUJETO_OBLIGADO.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/tipo-de-documento-debida-diligencia",
                    },
                    {
                        id: "tipoSujetoObligadoDiligencia",
                        title: "Tipo de sujeto obligado",
                        translate: "NAV.TIPO_SUJETO_OBLIGADO.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/tipo-sujeto-obligado-debidas-diligencias",
                    },
                    {
                        id: "tipoOperacionDiligencia",
                        title: "Tipo de operación",
                        translate: "NAV.TIPO_OPERACION.TITLE",
                        type: "item",
                        icon: "user",
                        url: "/tipo-operacion-debidas-diligencias",
                    },
                    // {
                    //   id       : 'tablaDeEvaluacionDebidaDiligencia',
                    //   title    : 'Tablas de evaluación',
                    //   translate: 'NAV.TABLADEEVALUACIONDEBIDADILIGENCIA.TITLE',
                    //   type     : 'item',
                    //   icon     : 'assignment_turned_in',
                    //   url      : '/tablas-de-evaluacion-debida-diligencia',
                    // }
                ],
            },
            {
                id: "sujetoObligadoDiligencia",
                title: "Sujetos obligados",
                translate: "NAV.SUJETO_OBLIGADO.TITLE",
                type: "item",
                icon: "supervisor_account",
                url: "/sujeto-obligado-debidas-diligencias",
            },
            {
                id: "formularioDeReferenciaDebidaDiligencia",
                title: "Formularios",
                translate: "NAV.FORMULARIOS.TITLE",
                type: "item",
                icon: "library_books",
                url: "/formularios-debida-diligencia",
            },
            {
                id: "misOperacionesDebidaDiligencia",
                title: "Operaciones",
                translate: "NAV.OPERACIONES.TITLE",
                type: "item",
                icon: "library_books",
                url: "/operaciones-debida-diligencia",
            },
        ],
    },

    {
        id: "verManual",
        title: "Ver Manual",
        translate: "NAV.VER_MANUAL.TITLE",
        type: "item",
        icon: "book",
        url: "/assets/manual.pdf",
        openInNewTab: true,
    },
    /*{
      id       : 'vistas',
      title    : 'Vistas',
      translate: 'NAV.VISTAS.TITLE',
      type     : 'item',
      icon     : 'bar_chart',
      url      : '/vistas',
  }*/
];
